"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareStepFormSchema = exports.sharePriceStepSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const constants_1 = require("../constants");
const quantityPrecision_1 = require("./quantityPrecision");
const getShareStepFormContext = (context) => (context ?? {});
const quantityFieldBaseSchema = () => (0, quantityPrecision_1.applyQuantityPrecisionRules)(yup.number().typeError(constants_1.NO_OF_SHARES_REQUIRED).positive(constants_1.NO_OF_SHARES_POSITIVE));
exports.sharePriceStepSchema = {
    calculationMethod: yup.string().required(constants_1.CALCULATION_METHOD_REQUIRED),
    amountPaid: yup.number().when("calculationMethod", {
        is: (method) => method === constants_1.TOTAL_PAID_AMOUNT || method === constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT,
        then: () => yup
            .number()
            .typeError(constants_1.AMOUNT_REQUIRED)
            .test("amountPaid", constants_1.AMOUNT_REQUIRED, (amountPaid) => amountPaid !== undefined)
            .test("amountPaid", constants_1.AMOUNT_NOT_NEG, (amountPaid) => amountPaid >= 0)
            .test("amountPaid", constants_1.AMOUNT_POSITIVE, function test(amountPaid) {
            if (this.parent.calculationMethod !== constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT)
                return true;
            return amountPaid > 0;
        }),
        otherwise: () => yup.number().notRequired(),
    }),
    quantityForAmountPaid: yup.number().when("calculationMethod", {
        is: constants_1.TOTAL_PAID_AMOUNT,
        then: () => quantityFieldBaseSchema()
            .test("quantityForAmountPaid", constants_1.NO_OF_SHARES_REQUIRED, (quantityForAmountPaid) => quantityForAmountPaid !== undefined)
            .test("quantityForAmountPaid", "Quantity cannot be more than available shares in selected share class", function test(quantityForAmountPaid) {
            const { isTransfer, shareClass, maxQuantity, method } = getShareStepFormContext(this.options.context);
            if (!isTransfer && !shareClass)
                return true;
            if (method === constants_1.TOTAL_PAID_AMOUNT && shareClass && maxQuantity !== undefined) {
                return quantityForAmountPaid <= maxQuantity;
            }
            return true;
        }),
        otherwise: () => yup.number().notRequired(),
    }),
    quantity: yup.number().when("calculationMethod", {
        is: constants_1.PRICE_PER_SHARE,
        then: () => quantityFieldBaseSchema()
            .test("quantity", constants_1.NO_OF_SHARES_REQUIRED, (quantity) => quantity !== undefined)
            .test("quantity", "Quantity cannot be more than available shares in selected share class", function test(quantity) {
            const { isTransfer, shareClass, maxQuantity, method } = getShareStepFormContext(this.options.context);
            if (!isTransfer && !shareClass)
                return true;
            if (method === constants_1.PRICE_PER_SHARE && shareClass && maxQuantity !== undefined) {
                return quantity <= maxQuantity;
            }
            return true;
        }),
        otherwise: () => yup.number().notRequired(),
    }),
    pricePerShare: yup.number().when("calculationMethod", {
        is: (method) => method === constants_1.PRICE_PER_SHARE || method === constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT,
        then: () => yup
            .number()
            .typeError(constants_1.PRICE_PER_SHARE_REQUIRED)
            .test("pricePerShare", constants_1.PRICE_PER_SHARE_REQUIRED, (pricePerShare) => pricePerShare !== undefined)
            .test("pricePerShare", constants_1.PRICE_PER_SHARE_NOT_NEG, (pricePerShare) => pricePerShare >= 0)
            .test("pricePerShare", constants_1.PRICE_PER_SHARE_POSITIVE, function test(pricePerShare) {
            if (this.parent.calculationMethod !== constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT)
                return true;
            return pricePerShare > 0;
        })
            .test("pricePerShare", constants_1.NO_OF_SHARES_POSITIVE, function test(pricePerShare) {
            if (this.parent.calculationMethod !== constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT)
                return true;
            const amountPaid = this.parent.amountPaid;
            // Negative/zero amountPaid or pricePerShare are already reported by their own field tests;
            // only check for the (positive ÷ positive) quotient rounding down to a zero quantity here.
            if (!amountPaid || amountPaid <= 0 || !pricePerShare || pricePerShare <= 0)
                return true;
            const roundedQuantity = Math.round((amountPaid / pricePerShare) * 1e6) / 1e6;
            return roundedQuantity > 0;
        })
            .test("pricePerShare", "Quantity cannot be more than available shares in selected share class", function test(pricePerShare) {
            const { isTransfer, shareClass, maxQuantity, method } = getShareStepFormContext(this.options.context);
            if (!isTransfer && !shareClass)
                return true;
            if (method !== constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT || !shareClass || maxQuantity === undefined)
                return true;
            const amountPaid = this.parent.amountPaid;
            if (!amountPaid || !pricePerShare)
                return true;
            // Compare the same rounded quantity the forms submit (round(amountPaid / pricePerShare, 6)) so a
            // quotient that rounds down to maxQuantity isn't rejected for exceeding it by a sub-micro-unit amount.
            const roundedQuantity = Math.round((amountPaid / pricePerShare) * 1e6) / 1e6;
            return roundedQuantity <= maxQuantity;
        }),
        otherwise: () => yup.number().notRequired(),
    }),
};
exports.ShareStepFormSchema = yup.object().shape({
    ...exports.sharePriceStepSchema,
    shareClassId: yup.string().trim().required(constants_1.SHARE_CLASS_REQUIRED),
    dateOfTransaction: yup
        .string()
        .trim()
        .required(constants_1.DATE_REQUIRED)
        .test("dateOfTransaction", constants_1.DATE_VALID, (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).isValid() && (0, mystake_common_sdk_1.getDateYear)(dateOfTransaction) > 1920)
        .test("dateOfTransaction", constants_1.DATE_OF_ISSUE_NOT_FUTURE, (dateOfTransaction) => (0, moment_1.default)(dateOfTransaction).diff((0, moment_1.default)(), "days") <= 0)
        .test("dateOfTransaction", constants_1.DATE_NOT_PRIOR_TO_COMPANY_REGISTRATION, function test(dateOfTransaction) {
        if (this.options.context) {
            const { dateOfRegistration } = this.options.context;
            if (dateOfRegistration) {
                return new Date(dateOfRegistration).getTime() - constants_1.MILLISECONDS_PER_DAY < new Date(dateOfTransaction).getTime();
            }
        }
        return true;
    }),
});
//# sourceMappingURL=ShareStepFormSchema.js.map